import { useMemo, useState } from "react";
import { ApprovalCard } from "@/components/mh/ApprovalCard";
import { Eyebrow } from "@/components/mh/bits";
import { useApprovals, useDeptMap } from "@/components/mh/hooks";
import { cn } from "@/lib/utils";

export default function Approvals() {
  const deps = useDeptMap();
  const { items, reload } = useApprovals();
  const [dept, setDept] = useState("all");
  const shown = useMemo(() => (dept === "all" ? items : items.filter((i) => i.department === dept)), [items, dept]);
  return (
    <div className="max-w-[1500px] mx-auto space-y-6" data-testid="approvals-page">
      <header className="mh-rise">
        <Eyebrow>Human-in-the-loop</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3">Your desk. <em className="text-muted-foreground">{items.length} waiting.</em></h1>
        <p className="text-sm sm:text-base text-muted-foreground mt-3 max-w-2xl">Agents pause here before high-impact actions. Approve to let the run continue to Act → Explain → Handoff, or reject to stop it.</p>
      </header>
      <div className="flex flex-wrap gap-2" data-testid="approvals-filter">
        {[{ slug: "all", name: "All", hex: "#fff" }, ...Object.values(deps)].map((d) => {
          const n = d.slug === "all" ? items.length : items.filter((i) => i.department === d.slug).length;
          return (
            <button key={d.slug} onClick={() => setDept(d.slug)} data-testid={`approvals-filter-${d.slug}`}
              className={cn("h-8 px-3.5 rounded-full border text-xs transition-[background-color,border-color] duration-200", dept === d.slug ? "bg-white text-black border-white" : "border-white/10 text-muted-foreground hover:border-white/30")}>
              {d.name} <span className="font-mono ml-1 opacity-70">{n}</span>
            </button>
          );
        })}
      </div>
      {shown.length === 0 ? (
        <p className="text-muted-foreground py-16 text-center" data-testid="approvals-empty">Nothing waiting. The house is humming.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-3">
          {shown.map((a) => <ApprovalCard key={a.id} item={a} dept={deps[a.department]} onDone={reload} />)}
        </div>
      )}
    </div>
  );
}
